var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9708 14.3847C18.207 13.9899 18.7812 13.9968 19.0079 14.397L23.1466 21.7055C23.3724 22.1043 23.086 22.5987 22.6278 22.6012L14.0905 22.6471C13.6231 22.6496 13.3324 22.1403 13.5723 21.7392L17.9708 14.3847Z",
    fill: "#D8D1CA",
    stroke: "#D8D1CA",
    strokeWidth: 2.15625
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28.3751,
    width: 8.625,
    height: 8.625,
    rx: 1.16,
    fill: "#D8D1CA",
    stroke: "#D8D1CA",
    strokeWidth: 2.15625
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.375,
    y: 14.0001,
    width: 8.625,
    height: 8.625,
    rx: 1.16,
    fill: "#D8D1CA",
    stroke: "#D8D1CA",
    strokeWidth: 2.15625
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.375,
    y: 28.3751,
    width: 8.625,
    height: 8.625,
    rx: 4.3125,
    fill: "#D8D1CA",
    stroke: "#D8D1CA",
    strokeWidth: 2.15625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.49dc3a4be61617ab9fee79566537df0d.svg";
export { ForwardRef as ReactComponent };